/*
  Rolamento suave com inércia (Lenis).
  Só age na roda do mouse / trackpad; no celular o toque segue nativo.
  Pausa quando o tema trava a rolagem (menu, carrinho, modais).
*/
(function () {
  if (typeof window.Lenis === 'undefined') return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Áreas com rolagem própria: a roda rola elas, não a página
  var NESTED_SCROLL =
    'cart-drawer, menu-drawer, .menu-drawer, .drawer, details[open] > .header__submenu, ' +
    'predictive-search, .predictive-search, .facets-wrapper, .mobile-facets, ' +
    'modal-dialog, product-modal, .product-popup-modal, [data-lenis-prevent]';

  var lenis = new window.Lenis({
    lerp: 0.08, // quanto menor, mais longa a continuação depois de parar
    wheelMultiplier: 1,
    smoothWheel: true,
    syncTouch: false,
    anchors: true,
    autoRaf: true,
    prevent: function (node) {
      return !!(node && node.closest && node.closest(NESTED_SCROLL));
    },
  });

  window.nilenLenis = lenis;

  // Pausa enquanto o tema travar a rolagem do body
  // (classes overflow-hidden*, que dependem da largura da tela)
  function syncLock() {
    var locked = window.getComputedStyle(document.body).overflowY === 'hidden';
    if (locked) lenis.stop();
    else lenis.start();
  }
  new MutationObserver(syncLock).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  syncLock();
})();
